import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconNearMeComponent } from "./med-icon-near-me.component";

@NgModule({
  declarations: [
    MedIconNearMeComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconNearMeComponent,
  ],
})
export class MedIconNearMeModule { }
